export { OnedayBinsoExplanationContainer as default } from "@/containers/StepGuideContainer";
